var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "c-card",
        {
          staticClass: "cardClassDetailForm no-margin",
          attrs: { title: "밀폐공간작업 상세정보" },
        },
        [
          _c("template", { slot: "card-detail" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4" },
              [
                _c("c-textarea", {
                  attrs: {
                    disabled: !_vm.isWriting,
                    editable: _vm.editable,
                    label: "출입사유",
                    name: "closeEntryResaon",
                  },
                  on: { dataChange: _vm.dataChange },
                  model: {
                    value: _vm.supWork.closeEntryResaon,
                    callback: function ($$v) {
                      _vm.$set(_vm.supWork, "closeEntryResaon", $$v)
                    },
                    expression: "supWork.closeEntryResaon",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4" },
              [
                _c("c-textarea", {
                  attrs: {
                    disabled: !_vm.isWriting,
                    editable: _vm.editable,
                    label: "밀폐장소의 예상위험",
                    name: "closeExpectedRisk",
                  },
                  on: { dataChange: _vm.dataChange },
                  model: {
                    value: _vm.supWork.closeExpectedRisk,
                    callback: function ($$v) {
                      _vm.$set(_vm.supWork, "closeExpectedRisk", $$v)
                    },
                    expression: "supWork.closeExpectedRisk",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3" },
          [
            _c("c-table", {
              staticClass: "q-mt-md",
              attrs: {
                isTitle: "",
                title: "안전조치 요구사항",
                columns: _vm.grid.columns,
                gridHeightAuto: true,
                data: _vm.supWork.checkResults,
                filtering: false,
                columnSetting: false,
                usePaging: false,
                editable: _vm.editable && _vm.isWriting,
                contentsField: _vm.contentsField,
              },
              on: { "table-data-change": _vm.tableDataChange },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3" },
          [
            _c(
              "c-table",
              {
                ref: "entrantTable",
                staticClass: "q-mt-md",
                attrs: {
                  title: "입출입자",
                  columns: _vm.gridEnter.columns,
                  gridHeightAuto: true,
                  data: _vm.supWork.entrants,
                  filtering: false,
                  columnSetting: false,
                  usePaging: false,
                  editable: _vm.editable && _vm.isWriting,
                  selection: "multiple",
                  rowKey: "sopWorkEntrantId",
                },
                scopedSlots: _vm._u([
                  {
                    key: "customArea",
                    fn: function ({ props, col }) {
                      return [
                        col.name === "deptUserName"
                          ? [
                              Boolean(props.row.userId)
                                ? [
                                    _vm._v(
                                      " " + _vm._s(props.row[col.name]) + " "
                                    ),
                                  ]
                                : [
                                    _c("c-text-column", {
                                      attrs: {
                                        editable: _vm.editable,
                                        disabled: !_vm.isWriting,
                                        col: col,
                                        props: props,
                                      },
                                      on: {
                                        datachange: function ($event) {
                                          return _vm.entrantDataChange(props)
                                        },
                                      },
                                    }),
                                  ],
                            ]
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              },
              [
                _c(
                  "template",
                  { slot: "table-button" },
                  [
                    _c(
                      "q-btn-group",
                      { attrs: { outline: "" } },
                      [
                        _vm.editable && _vm.isWriting
                          ? _c("c-btn", {
                              attrs: {
                                label: "추가(외부)",
                                icon: "add",
                                showLoading: false,
                              },
                              on: { btnClicked: _vm.addEntrantVendor },
                            })
                          : _vm._e(),
                        _vm.editable && _vm.isWriting
                          ? _c("c-btn", {
                              attrs: {
                                label: "추가(임직원)",
                                icon: "add",
                                showLoading: false,
                              },
                              on: { btnClicked: _vm.addEntrant },
                            })
                          : _vm._e(),
                        _vm.editable && _vm.isWriting
                          ? _c("c-btn", {
                              attrs: {
                                label: "제외",
                                icon: "remove",
                                showLoading: false,
                              },
                              on: { btnClicked: _vm.removeEntrant },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              2
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6" },
          [
            _c(
              "c-mobile-table",
              {
                ref: "gasTable",
                staticClass: "q-mt-md",
                attrs: {
                  isTitle: "",
                  title: "가스농도 측정",
                  columns: _vm.grid2.columns,
                  gridHeightAuto: true,
                  data: _vm.supWork.gases,
                  filtering: false,
                  columnSetting: false,
                  usePaging: false,
                  editable: _vm.editable && _vm.isWriting,
                  selection: "multiple",
                  rowKey: "sopGasCheckId",
                },
              },
              [
                _c(
                  "template",
                  { slot: "table-button" },
                  [
                    _c(
                      "q-btn-group",
                      { attrs: { outline: "" } },
                      [
                        _vm.editable && _vm.isWriting
                          ? _c("c-btn", {
                              attrs: {
                                label: "추가",
                                icon: "add",
                                showLoading: false,
                              },
                              on: { btnClicked: _vm.addGas },
                            })
                          : _vm._e(),
                        _vm.editable && _vm.isWriting
                          ? _c("c-btn", {
                              attrs: {
                                label: "제외",
                                icon: "remove",
                                showLoading: false,
                              },
                              on: { btnClicked: _vm.removeGas },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              2
            ),
          ],
          1
        ),
      ]),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }